import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {

  transform(list: any, keys: string, searchText: string): any {

    // If any parameter doesnot exists, donot perform search function
    if ( !searchText || !list || !keys) {
      return list;
    }
    // Return the filtered list
    return (list || []).filter(
      (item) => {
        return keys.split(',').some(
          (key) => {
            let isSearchTextExists = item.hasOwnProperty(key);
            if (isSearchTextExists) {
              isSearchTextExists = (new RegExp(searchText.toLowerCase()).test(item[key].toLowerCase()));
            }
            return isSearchTextExists;
          }
        );
      }
    );
  }

}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/pipes/search.pipe.ts